// @ts-nocheck
import React, { useMemo } from 'react';
import { ShellWindowProps } from 'src/types/shell';
import { MfePropsType } from 'src/types/mfeProps';
import projectNames from 'src/configs/projectNames';
import { ThemeProvider } from '@veneer/theme';
import RootProvider from 'src/contexts/Root/RootProvider';
declare global {
  interface Window {
    Shell: ShellWindowProps;
  }
}

export default function Root({
  stack,
  useToast,
  localizationResources,
  session,
  children,
  id
}: MfePropsType & { id: string }) {
  const interfaces = window.Shell.v1;
  const { theme } = interfaces || {};

  const themeProviderProps = useMemo(() => {
    return {
      ...theme?.getThemeProviderProperties(),
      mode: theme?.getUserThemeMode?.()
    };
  }, [theme]);

  // You can find the "stack  " information by props
  // const stack = props.stack.
  return (
    <section
      className={`${projectNames.namespace}`}
      id={`${projectNames.packageJsonName}-${id}`}
    >
      <ThemeProvider {...themeProviderProps}>
        <RootProvider
          {...{
            stack,
            useToast,
            localizationResources,
            session,
            ...interfaces
          }}
        >
          {children}
        </RootProvider>
      </ThemeProvider>
    </section>
  );
}
